import React from 'react';
import PropTypes from 'prop-types';
import api from '../../../Api';
import { VerifyCommunityStatus } from '../UI/VerifyCommunityStatus';

const ExclusiveContext = React.createContext({});
const {
	Provider: ExclusiveProvider,
	Consumer: ExclusiveConsumer,
} = ExclusiveContext;

export const connectToExclusiveStore = Component => {
	const WrappedComponent = props => {
		return (
			<ExclusiveConsumer>
				{exclusiveStore => {
					return (
						<Component exclusiveStore={exclusiveStore} {...props} />
					);
				}}
			</ExclusiveConsumer>
		);
	};

	WrappedComponent.displayName = Component.displayName;

	return WrappedComponent;
};

export default class ExclusiveStore extends React.Component {
	static propTypes = {
		children: PropTypes.oneOfType([
			PropTypes.element,
			PropTypes.arrayOf(PropTypes.element),
		]),
	};

	state = {
		appUserId: null,
		isLoading: true,
		selectedValue: null,
		accessCode: null,
		verifyStatus: VerifyCommunityStatus.None,
		communities: [],
	};

	render() {
		const store = this.getExclusiveStore();
		const props = this.props;

		return (
			<ExclusiveProvider value={store}>
				{props.children}
			</ExclusiveProvider>
		);
	}

	componentDidMount() {
		this.fetchUserInfo();
		this.fetchExclusiveCommunities();
	}

	fetchUserInfo() {
		api.get('/api/me').then(result =>
			this.setState({ appUserId: result.id }),
		);
	}

	fetchExclusiveCommunities() {
		api.get('/api/affiliations/exclusive').then(result =>
			this.setState({
				isLoading: false,
				selectedValue: null,
				accessCode: null,
				verifyStatus: VerifyCommunityStatus.None,
				communities: this.processCommunities(result.communities),
			}),
		);
	}

	getExclusiveStore() {
		const state = this.state;

		return {
			state,
			onRadioChange: event => {
				event.preventDefault();

				const selectedValue = event.target.value;
				const accessCode = null;
				const verifyStatus = VerifyCommunityStatus.None;

				this.setState({
					selectedValue,
					accessCode,
					verifyStatus,
				});
			},
			cancelVerify: () => {
				const selectedValue = null;
				const accessCode = null;
				const verifyStatus = VerifyCommunityStatus.None;

				this.setState({
					selectedValue,
					accessCode,
					verifyStatus,
				});
			},
			submitVerify: () => {
				let verifyStatus = VerifyCommunityStatus.NoAccessCode;

				const accessCode = state.accessCode;
				const communityId = state.selectedValue;
				const community = state.communities[communityId];

				if (accessCode) {
					verifyStatus = VerifyCommunityStatus.Joining;

					const validType = community.type;
					const appUserId = state.appUserId;
					const urlBase = process.env.REACT_APP_API_URL;
					const url = `${urlBase}/GetJSONData.aspx?m=User
						&builder=validateAffiliation
						&groupId=${communityId}
						&affCode=${accessCode}
						&validType=${validType}
						&appUserId=${appUserId}`;

					fetch(url)
						.then(response => response.json())
						.then(response => {
							let verifyStatus =
								VerifyCommunityStatus.InvalidAccessCode;

							if (response.code === 'SUCCESS') {
								verifyStatus = VerifyCommunityStatus.Joined;
							}

							this.setState({ verifyStatus });
						});
				}

				this.setState({ verifyStatus });
			},
			accessCodeChange: event => {
				const accessCode = event.target.value;

				this.setState({ accessCode });
			},
		};
	}

	processCommunities = communities => {
		return communities.reduce((map, community) => {
			map[community.id] = this.processCommunity(community);
			return map;
		}, {});
	};

	processCommunity = community => {
		return {
			id: community.id,
			name: community.name,
			type: community.type || 0,
		};
	};
}
